import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { PASearch } from "../PA.Core/PASearch";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { SalesOrgSearch } from "../PA.UIM.MD/SalesOrgSearch"
import { MasterDataSetSearch } from "../PA.UIM.MD/MasterDataSetSearch"

const vUI_PPAModel_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_PPA_MODEL_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Model Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    MODEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Model Id', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    MODEL_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Model Name',
            columnResourceName: 'colPPAModelName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    COMMENTS: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Comments', columnResourceName: 'colComments', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Start Date',
            columnResourceName: 'colStartDate',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'End Date',
            columnResourceName: 'colEndDate',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Org WB Id',
            columnResourceName: 'colCustSARWBId',
            alignment: HorizAlignment.Center
        },
        domainOptions: { maxLength: 256, search: SalesOrgSearch, profileId: "default", searchCondition: {} }
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'MDSET ID', columnResourceName: 'colMDSetId', alignment: HorizAlignment.Center },
        domainOptions: { maxLength: 256, search: MasterDataSetSearch, profileId: "default", searchCondition: {} }
    }

}

const PPAModelSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_PPA_MODEL_ID',
        id_ui: 'MODEL_ID',
        name: 'MODEL_NAME'

    },

    searchProviderFields: vUI_PPAModel_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            const findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_PPAModel_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                });
        })
    }
};

const PPAModelSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5SourceId: "PPAModelSearchProfileByName" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'MODEL_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'MODEL_NAME', renderOptions: {} }
    ], //ISearchFields
    profileDisplayFields: [
        'MODEL_ID', 'MODEL_NAME', 'COMMENTS',
        "START_DT", "END_DT"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PPAModelSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PPAModelSearch: ISearch = {
    searchName: "Find PPA Model",
    renderOptions: { ui5ResourceId: "PPAModelSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [PPAModelSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("PPAModelBO", "PPAModel", PPAModelSearch, "PPA Model Search")

export { PPAModelSearch }